export default {
    reviews: 'reviews',
    title: 'Product ratings and ratings',
    resetFilters: 'Reset Filters',
    productComments: {
        title: 'User ratings and comments',
        seeAll: 'See all reviews',
        postComment: 'Post a comment',
        comments: 'Comments',
        hideComments: 'Hide',
        showComments: 'Show comments',
        button: {
            cancel: 'Cancel',
            post: 'Post',
        }
    }
}
